import { Button, FormControl, Stack, TextField, FormControlLabel, Checkbox } from '@mui/material';
import { useState } from 'react';
import { SectionHeader } from '../SectionHeader';
import { ARM_SEVERITY_VALUES, HEMI_NEGLECT_VALUES, SEVERITY_VALUES, SIDE_VALUES_WITH_NONE } from './Config';
import { CustomSelect } from './CustomSelect';
import axios from '../../../util/Axios';

const wide = '360px';
const narrow = '172px';

export function EditNeurologicalExamination({ testId, neurologicalExamination, onCancel, onSaved }) {
  const [aphasia, setAphasia] = useState(neurologicalExamination?.aphasia || '');
  const [dysarthria, setDysarthria] = useState(neurologicalExamination?.dysarthria || '');
  const [facialDroopSide, setFacialDroopSide] = useState(neurologicalExamination?.facialDroop?.side || '');
  const changeFacialDroopSide = (val) => {
    setFacialDroopSide(val);
    if (val === 'NONE') {
      setFacialDroopSeverity('NONE');
    }
  };
  const [facialDroopSeverity, setFacialDroopSeverity] = useState(neurologicalExamination?.facialDroop?.severity || '');
  const [armWeaknessSide, setArmWeaknessSide] = useState(neurologicalExamination?.armWeakness?.side || '');
  const changeArmWeaknessSide = (val) => {
    setArmWeaknessSide(val);
    if (val === 'NONE') {
      setArmWeaknessLevel(0);
    }
  };
  const [armWeaknessLevel, setArmWeaknessLevel] = useState(neurologicalExamination?.armWeakness?.level || '');
  const [hemineglect, setHeminemglect] = useState(neurologicalExamination?.hemineglect || '');
  const [nihss, setNihss] = useState(neurologicalExamination?.nihss);
  const [tia, setTia] = useState(neurologicalExamination?.tia);

  const handleSave = () => {
    const neurogicalExaminationToSave = {
      ...neurologicalExamination,
      aphasia: aphasia || null,
      dysarthria: dysarthria || null,
      facialDroop: { side: facialDroopSide || null, severity: facialDroopSeverity || null },
      armWeakness: { side: armWeaknessSide || null, level: armWeaknessLevel || null },
      hemineglect: hemineglect || null,
      nihss: nihss || 0,
      tia
    };

    axios(`/strokeTests/${testId}/neurologicalExamination/v2`, {
      method: 'PUT',
      data: neurogicalExaminationToSave,
    }).then(() => onSaved(neurogicalExaminationToSave), onCancel);
  };

  return (
    <Stack>
      <SectionHeader name="Neurological Examination" />
      <CustomSelect value={aphasia} valueChanged={setAphasia} label="Aphasia" values={SEVERITY_VALUES} width={wide} />
      <CustomSelect value={dysarthria} valueChanged={setDysarthria} label="Dysarthria" values={SEVERITY_VALUES} width={wide} />
      <Stack direction="row" spacing={1} alignItems="center">
        <CustomSelect value={facialDroopSide} valueChanged={changeFacialDroopSide} label="Facial droop side" values={SIDE_VALUES_WITH_NONE} width={narrow} />
        <CustomSelect value={facialDroopSeverity} disabled={facialDroopSide === 'NONE'} valueChanged={setFacialDroopSeverity} label="Facial droop severity" values={SEVERITY_VALUES} width={narrow} />
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center">
        <CustomSelect value={armWeaknessSide} valueChanged={changeArmWeaknessSide} label="Arm weakness side" values={SIDE_VALUES_WITH_NONE} width={narrow} />
        <CustomSelect value={armWeaknessLevel} disabled={armWeaknessSide === 'NONE'} valueChanged={setArmWeaknessLevel} label="Arm weakness severity" values={ARM_SEVERITY_VALUES} width={narrow} />
      </Stack>
      <CustomSelect value={hemineglect} valueChanged={setHeminemglect} label="Hemineglect" values={HEMI_NEGLECT_VALUES} width={wide} />
      <FormControlLabel control={<Checkbox checked={tia} onChange={(e) => setTia(e.target.checked)} />} label="TIA" />
      <FormControl sx={{ m: 1, width: wide || 300 }} size="small">
        <TextField
          id="hihss"
          label="NIHSS"
          type="number"
          value={nihss}
          onChange={(event) => setNihss(event.target.value)}
          InputProps={{ inputProps: { min: 0, max: 42 } }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </FormControl>
      <Stack direction="row" justifyContent="flex-end" spacing={1}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>
          {' '}
          Save{' '}
        </Button>
      </Stack>
    </Stack>
  );
}
